import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function BookOpen({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'22px'} height={'20px'} viewBox={'0 0 22 20'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-1.000000, -2.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M3,4 L3,17 L9,17 C9.72857429,17 10.4116533,17.1947886 11,17.5351288 L11,7 C11,5.34314575 9.65685425,4 8,4 L3,4 Z M2,2 L8,2 C10.7614237,2 13,4.23857625 13,7 L13,21 C13,22.3333333 11,22.3333333 11,21 C11,19.8954305 10.1045695,19 9,19 L2,19 C1.44771525,19 1,18.5522847 1,18 L1,3 C1,2.44771525 1.44771525,2 2,2 Z M22,2 C22.5522847,2 23,2.44771525 23,3 L23,18 C23,18.5522847 22.5522847,19 22,19 L15,19 C13.8954305,19 13,19.8954305 13,21 L11,21 L11,7 C11,4.23857625 13.2385763,2 16,2 L22,2 Z M21,4 L16,4 C14.3431458,4 13,5.34314575 13,7 L13,17.5351288 C13.5883467,17.1947886 14.2714257,17 15,17 L21,17 L21,4 Z M13,21 C13,22.3333333 11,22.3333333 11,21 C11,19.5194353 11.8043973,18.2267476 13,17.5351288 L13,21 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

BookOpen.propTypes = {
  className: PropTypes.string,
}
